export const useButtonText = (): string => {
  // const isDesktop = useIsDesktop();

  // TODO: Добавить в микрофронт селектор, доступный извне
  // Пока всегда показываем заглушку "Добавить объект"
  // const estimationTarget: EEstimationTargets = useSelector(selectEstimationTarget);

  // if (!isDesktop) {
  //   return 'Добавить объект';
  // }

  // switch (estimationTarget) {
  //   case EEstimationTargets.house:
  //     return 'Добавить дом';
  //
  //   case EEstimationTargets.land:
  //     return 'Добавить участок';
  //
  //   default:
  //     return 'Добавить квартиру';
  // }

  return 'Добавить объект';
};
